export default [
  {
    path: 'riwayat',
    name: 'sale list',
    component: () => import('@/views/app/sale/list/page-list.vue'),
    meta: { title: 'Daftar Penjualan' },
  },
  {
    path: ':id',
    name: 'sale detail',
    component: () => import('@/views/app/sale/detail/page-detail.vue'),
    meta: { title: 'Detail Penjualan' },
  },
]
